// 指数数据
const state = {
  index: []
}

const mutations = {
  SET_INDEXDATA: (state, data) => {
    state.index = [...data]
  }
}

const actions = {
  setIndexData ({ commit }, data) {
    commit('SET_INDEXDATA', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
